import React from 'react'
import { Users, AlertTriangle, TrendingUp, Activity } from 'lucide-react'
import './QuickStats.css'

function QuickStats({ stats }) {
  if (!stats) return null

  const statsCards = [
    {
      icon: <Users size={24} />,
      label: 'Total Patients',
      value: stats.total_patients,
      color: '#4A90A4',
    },
    {
      icon: <AlertTriangle size={24} />,
      label: 'High Risk',
      value: stats.risk_distribution?.high?.count || 0,
      color: '#EF4444',
      subtext: `${stats.risk_distribution?.high?.percentage || 0}% of patients`
    },
    {
      icon: <TrendingUp size={24} />,
      label: 'Avg Medication Adherence',
      value: `${stats.adherence_metrics?.medication?.average || 0}%`,
      color: '#10B981',
    },
    {
      icon: <Activity size={24} />,
      label: 'Wearable Adoption',
      value: `${stats.wearable_adoption?.adoption_rate || 0}%`,
      color: '#3B82F6',
      subtext: `${stats.wearable_adoption?.patients_with_devices || 0} patients`
    }
  ]

  return (
    <div className="quick-stats">
      {statsCards.map((stat, index) => (
        <div key={index} className="stat-card" style={{ borderTopColor: stat.color }}>
          <div className="stat-icon" style={{ color: stat.color }}>
            {stat.icon}
          </div>
          <div className="stat-content">
            <div className="stat-label">{stat.label}</div>
            <div className="stat-value">{stat.value}</div>
            {stat.subtext && <div className="stat-subtext">{stat.subtext}</div>}
          </div>
        </div>
      ))}
    </div>
  )
}

export default QuickStats